module.exports = __webpack_public_path__ + "media/images/awards/award-photo-3-191dbaca440801cab0408726fb72b7e1.jpeg";